import React from 'react';
import Hero from '../components/Home/Hero';
import ServicesList from '../components/Services/ServicesList';

const Home = () => {
  return (
    <div>
      <Hero />
      <ServicesList />
    </div>
  );
};

export default Home;